import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';

export const featureFlagApi = {
  getFlags: () => axios.get<Record<string, boolean>>(`${API_BASE}/public/feature-flags`),
};
